import React from "react";
import { Columns3 } from "@/components/icons";
import type { VisibilityState } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuSeparator,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useT } from "@/app/localization";

interface ColumnDef {
  id: string;
  label: string;
}

interface ColumnChooserProps {
  columns: ColumnDef[];
  visibility: VisibilityState;
  onToggle: (columnId: string, visible: boolean) => void;
  onReset: () => void;
}

export function ColumnChooser({ columns, visibility, onToggle, onReset }: ColumnChooserProps) {
  const t = useT();
  const chooseLabel = t("operator.columns.choose");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" title={chooseLabel} aria-label={chooseLabel}>
          <Columns3 className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {columns.map((col) => (
          <DropdownMenuCheckboxItem
            key={col.id}
            checked={visibility[col.id] !== false}
            onCheckedChange={(checked) => onToggle(col.id, !!checked)}
          >
            {col.label}
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onReset} className="text-xs opacity-70">
          {t("operator.columns.reset")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
